import { FetchParameters } from "../types/api.types";

export const getUrlParam = (key: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(key);
};

export const parseUrlParams = (): Partial<FetchParameters> => {
  const urlParams = new URLSearchParams(window.location.search);

  const direction: FetchParameters["direction"] =
    urlParams.get("direction") === "Using" ? "Using" : "Supplying";

  const pickUpLocationUnlocode: FetchParameters["pickUpLocationUnlocode"] =
    urlParams.get("pickUpLocationUnlocode")?.split(",") || [];

  const dropOffLocationUnlocode: FetchParameters["dropOffLocationUnlocode"] =
    urlParams.get("dropOffLocationUnlocode")?.split(",") || [];

  // Assign params to object and return it
  const params: Partial<FetchParameters> = {
    direction,
    pickUpLocationUnlocode,
    dropOffLocationUnlocode,
  };

  return params;
};
